import { EMPTY_RESUME_SG_CHARGE_MODEL } from "presentation/model/ResumeSGCharge/ResumeSGChargeModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: ResumeSGChargeProvider,
    useTracked: useResumeSGChargeTracked
} = createContainer(() => useState(EMPTY_RESUME_SG_CHARGE_MODEL), { concurrentMode: true });
export { ResumeSGChargeProvider, useResumeSGChargeTracked };

